/* Ishira product page (B-021b, generalized for all products 2026-10-09 THEME-002). No dependencies. */
(function () {
  'use strict';

  var SHAPES = {
    round: ['rd', 'rnd', 'br'], oval: ['ov'], cushion: ['cu', 'cus', 'cs'], emerald: ['em'],
    pear: ['pe', 'ps'], princess: ['pr', 'pc'], marquise: ['mq', 'mr'], radiant: ['ra', 'rad'],
    asscher: ['ac', 'as'], heart: ['hr', 'ht', 'hs']
  };
  var COLORS = { yellow: 'y', white: 'w', rose: 'r' };

  function low(s) { return (s || '').toString().toLowerCase(); }
  function word(text, w) { return new RegExp('(^|[^a-z])' + w + '([^a-z]|$)').test(text); }
  function shapeKey(v) { v = low(v); for (var k in SHAPES) { if (v.indexOf(k) > -1) return k; } return v; }
  function colorKey(v) { v = low(v); for (var k in COLORS) { if (v.indexOf(k) > -1) return k; } return v.indexOf('pink') > -1 ? 'rose' : null; }
  function qsa(el, s) { return Array.prototype.slice.call(el.querySelectorAll(s)); }

  function PDP(root) {
    var self = this;
    this.root = root;
    this.form = root.querySelector('form.ish-form');
    if (!this.form) return;
    this.idInput = root.querySelector('[data-ish-variant-id]');
    this.atc = root.querySelector('[data-ish-atc]');
    this.err = root.querySelector('[data-ish-error]');
    this.igiMin = parseFloat(root.dataset.igiMin || '1') || 1;
    this.sizeIndex = parseInt(root.dataset.sizeIndex || '0', 10) - 1;
    this.sizeProp = root.dataset.sizeProp === 'true';
    this.isRing = root.dataset.ring === 'true';
    this.title = root.dataset.title || '';
    this.current = JSON.parse(root.querySelector('[data-ish-current]').textContent);
    var vEl = root.querySelector('[data-ish-variants]');
    this.variants = vEl ? JSON.parse(vEl.textContent) : null;
    this.state = this.current.options.slice();
    if (this.sizeIndex > -1 && root.dataset.sizeChosen !== 'true') this.state[this.sizeIndex] = null;

    this.options = qsa(root, '[data-ish-option]').map(function (el) {
      return { el: el, idx: parseInt(el.dataset.ishOption, 10) - 1, kind: el.dataset.kind };
    });
    this.shapeOpt = this.options.filter(function (o) { return o.kind === 'shape'; })[0];
    this.metalOpts = this.options.filter(function (o) { return o.kind === 'metal' || o.kind === 'color' || o.el.hasAttribute('data-metalish'); });

    this.options.forEach(function (o) {
      if (o.kind === 'size' || o.kind === 'select') {
        o.el.querySelector('select').addEventListener('change', function (e) {
          self.state[o.idx] = e.target.value || null;
          self.clearError();
          self.update(o.idx);
        });
      } else if (o.kind === 'metal') {
        o.entries = qsa(o.el, '[data-ish-metal-entry]').map(function (s) {
          return { v: s.dataset.v, c: s.dataset.c, k: s.dataset.k, id: s.dataset.valueId };
        });
        o.el.addEventListener('change', function () { self.onMetal(o); });
      } else {
        o.el.addEventListener('change', function (e) {
          if (!e.target.matches('input[type=radio]')) return;
          self.state[o.idx] = e.target.value;
          self.update(o.idx);
        });
      }
    });

    var propSel = root.querySelector('[data-ish-size-prop] select');
    if (propSel) {
      propSel.addEventListener('change', function () { self.clearError(); self.syncDynamic(); });
      // The select is `required` (no-JS safety net); show our own message instead of the browser bubble.
      propSel.addEventListener('invalid', function (e) { e.preventDefault(); self.validate(); });
    }

    this.form.addEventListener('submit', function (e) { self.submit(e); });
    this.initExtras();
    this.initGallery();
    this.initSticky();
    this.initDialog();
    this.render(this.current, true);
    if (this.variants) this.markAvailability();
  }

  /* ---------- Options ---------- */
  PDP.prototype.onMetal = function (o) {
    var c = (o.el.querySelector('[data-ish-sub=color]:checked') || {}).value;
    var k = (o.el.querySelector('[data-ish-sub=karat]:checked') || {}).value;
    var hit = o.entries.filter(function (e) { return e.c === c && e.k === k; })[0] ||
      o.entries.filter(function (e) { return e.c === c; })[0];
    if (!hit) return;
    if (hit.k !== k) {
      var kr = o.el.querySelector('[data-ish-sub=karat][value="' + hit.k + '"]');
      if (kr) kr.checked = true;
    }
    this.state[o.idx] = hit.v;
    this.update(o.idx);
  };

  PDP.prototype.matches = function (v, skip) {
    for (var i = 0; i < this.state.length; i++) {
      if (i === skip || this.state[i] == null) continue;
      if (v.options[i] !== this.state[i]) return false;
    }
    return true;
  };

  PDP.prototype.update = function (changedIdx) {
    var self = this;
    this.syncDynamic();
    if (this.variants) {
      var list = this.variants.filter(function (v) { return self.matches(v); });
      var v = list.filter(function (x) { return x.available; })[0] || list[0];
      if (!v) {
        // Combination does not exist: keep the option just changed, take the closest variant.
        var keep = this.state[changedIdx];
        v = this.variants.filter(function (x) { return x.options[changedIdx] === keep; })[0];
        if (!v) return;
        for (var i = 0; i < this.state.length; i++) {
          if (this.state[i] != null || i !== this.sizeIndex) this.state[i] = v.options[i];
        }
        this.syncControls();
      }
      this.render(v);
      this.markAvailability();
    } else {
      this.fetchVariant();
    }
  };

  PDP.prototype.valueId = function (o, value) {
    if (o.kind === 'metal') {
      var e = o.entries.filter(function (x) { return x.v === value; })[0];
      return e && e.id;
    }
    var el = qsa(o.el, '[data-value-id]').filter(function (x) { return x.value === value; })[0];
    return el && el.dataset.valueId;
  };

  PDP.prototype.fetchVariant = function () {
    var self = this;
    var ids = this.options.slice().sort(function (a, b) { return a.idx - b.idx; }).map(function (o) {
      var val = self.state[o.idx] != null ? self.state[o.idx] : self.current.options[o.idx];
      return self.valueId(o, val);
    });
    if (ids.some(function (x) { return !x; })) return;
    if (this.ctrl) this.ctrl.abort();
    this.ctrl = window.AbortController ? new AbortController() : null;
    var url = this.root.dataset.url + '?option_values=' + ids.join(',') + '&section_id=ishira-variant-data';
    this.root.classList.add('is-loading');
    fetch(url, this.ctrl ? { signal: this.ctrl.signal } : {}).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var s = doc.querySelector('[data-ish-vd]');
      if (!s) return;
      var data = JSON.parse(s.textContent);
      self.render(data.variant);
      self.markFromValues(data.values);
    }).catch(function () {}).then(function () { self.root.classList.remove('is-loading'); });
  };

  PDP.prototype.syncControls = function () {
    var self = this;
    this.options.forEach(function (o) {
      var val = self.state[o.idx];
      if (o.kind === 'size' || o.kind === 'select') { o.el.querySelector('select').value = val || ''; return; }
      if (o.kind === 'metal') {
        var e = o.entries.filter(function (x) { return x.v === val; })[0];
        if (!e) return;
        var c = o.el.querySelector('[data-ish-sub=color][value="' + e.c + '"]'); if (c) c.checked = true;
        var k = o.el.querySelector('[data-ish-sub=karat][value="' + e.k + '"]'); if (k) k.checked = true;
        return;
      }
      qsa(o.el, 'input[type=radio]').forEach(function (r) { r.checked = r.value === val; });
    });
  };

  PDP.prototype.markAvailability = function () {
    var self = this;
    this.options.forEach(function (o) {
      if (o.kind === 'size' || o.kind === 'select') {
        qsa(o.el, 'option[data-value-id]').forEach(function (op) {
          var ok = self.variants.some(function (v) { return v.options[o.idx] === op.value && self.matches(v, o.idx); });
          op.textContent = op.value + (ok ? '' : ' (unavailable)');
        });
        return;
      }
      if (o.kind === 'metal') {
        qsa(o.el, '[data-ish-sub]').forEach(function (r) {
          var sub = r.dataset.ishSub;
          var ok = o.entries.some(function (e) {
            if (sub === 'color' ? e.c !== r.value : e.k !== r.value) return false;
            if (sub === 'karat') { var cc = (o.el.querySelector('[data-ish-sub=color]:checked') || {}).value; if (cc && e.c !== cc) return false; }
            return self.variants.some(function (v) { return v.options[o.idx] === e.v && self.matches(v, o.idx); });
          });
          r.nextElementSibling.classList.toggle('is-unavailable', !ok);
        });
        return;
      }
      qsa(o.el, 'input[type=radio]').forEach(function (r) {
        var ok = self.variants.some(function (v) { return v.options[o.idx] === r.value && self.matches(v, o.idx); });
        r.nextElementSibling.classList.toggle('is-unavailable', !ok);
      });
    });
  };

  PDP.prototype.markFromValues = function (values) {
    this.options.forEach(function (o) {
      var list = values[o.idx] || [];
      var byId = {}; list.forEach(function (x) { byId[String(x.id)] = x; });
      if (o.kind === 'metal') return;
      qsa(o.el, '[data-value-id]').forEach(function (el) {
        var info = byId[el.dataset.valueId];
        var ok = !info || info.e !== false;
        if (el.tagName === 'OPTION') el.textContent = el.value + (ok ? '' : ' (unavailable)');
        else if (el.nextElementSibling) el.nextElementSibling.classList.toggle('is-unavailable', !ok);
      });
    });
  };

  /* ---------- Render ---------- */
  PDP.prototype.render = function (v, initial) {
    var self = this, r = this.root;
    this.current = v;
    this.idInput.value = v.id;
    r.querySelector('[data-ish-price]').textContent = v.price;
    var cmp = r.querySelector('[data-ish-compare]');
    // Sale pricing (THEME-013): shown only when this variant has a real compare-at price above its price.
    var onSale = !!(v.compare && v.save);
    if (cmp) {
      var cmpVal = cmp.querySelector('[data-ish-compare-val]');
      (cmpVal || cmp).textContent = onSale ? v.compare : '';
      cmp.hidden = !onSale;
    }
    var save = r.querySelector('[data-ish-save]');
    if (save) { save.textContent = onSale ? 'Save ' + v.save : ''; save.hidden = !onSale; }
    var pw = r.querySelector('[data-ish-price-wrap]'); if (pw) pw.classList.toggle('is-sale', onSale);
    var sp = r.querySelector('[data-ish-sticky-price]'); if (sp) sp.textContent = v.price;
    var ap = r.querySelector('[data-ish-atc-price]'); if (ap) ap.textContent = v.price;
    this.updateAffirm(v, initial);
    this.atc.disabled = !v.available;
    r.querySelector('[data-ish-atc-text]').textContent = v.available ? 'Add to cart' : 'Sold out';

    this.options.forEach(function (o) {
      var val = self.state[o.idx] != null ? self.state[o.idx] : v.options[o.idx];
      var lab = o.el.querySelector('[data-ish-selected]'); if (lab) lab.textContent = val;
      var spec = r.querySelector('[data-ish-spec-opt="' + (o.idx + 1) + '"]'); if (spec) spec.textContent = val;
    });
    var sku = r.querySelector('[data-ish-spec="sku"]'); if (sku) sku.textContent = v.sku || '—';

    var gold = this.goldLabel(v);
    var gEl = r.querySelector('[data-ish-gold]'), gLi = r.querySelector('[data-ish-gold-li]');
    if (gEl && gLi) { gLi.hidden = !gold; gEl.textContent = gold || ''; }
    // PDP v2: metal in the gallery caption and the at-a-glance grid
    var cap = r.querySelector('[data-ish-cap-metal]'); if (cap) cap.textContent = gold ? ' · shown in ' + gold : '';
    var gm = r.querySelector('[data-ish-glance-metal]'), gmv = r.querySelector('[data-ish-gold-glance]');
    if (gm && gmv) { gm.hidden = !gold; gmv.textContent = gold ? 'Solid ' + gold : ''; }
    // PDP v2: shipping line by threshold (never "free shipping" below $1,000)
    var ship = r.querySelector('[data-ish-ship]');
    if (ship && v.cents != null) {
      var over = v.cents >= parseInt(ship.dataset.threshold || '100000', 10);
      ship.querySelector('[data-ish-ship-text]').textContent = over ? ship.dataset.over : ship.dataset.under;
    }
    var ct = parseFloat(v.ct) || 0;
    var igi = r.querySelector('[data-ish-igi]'); if (igi) igi.hidden = !(ct >= this.igiMin);
    var igiOn = !!r.querySelector('[data-ish-igi-static]') || (igi && !igi.hidden);
    var shipLi = r.querySelector('[data-ish-ship-li]'); if (shipLi) shipLi.hidden = !!igiOn;
    var ctRow = r.querySelector('[data-ish-spec-ct-row]');
    if (ctRow) { ctRow.hidden = !ct; r.querySelector('[data-ish-spec-ct]').textContent = ct ? ct.toFixed(2) + ' ct lab-grown' : ''; }

    if (!initial && this.allChosen() && window.history.replaceState) {
      var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', u.toString());
    }
    this.filterGallery(v, initial);
  };

  /* Affirm "Pay over time" message: the element is server-rendered (class affirm-as-low-as), so the Affirm app
     script does not insert its own; we keep data-amount in sync with the selected variant and ask Affirm to refresh. */
  PDP.prototype.updateAffirm = function (v, initial) {
    var el = this.root.querySelector('[data-ish-affirm]');
    if (!el || !v.cents) return;
    if (String(el.getAttribute('data-amount')) === String(v.cents) && initial) return;
    el.setAttribute('data-amount', String(v.cents));
    try {
      if (window.affirm && window.affirm.ui && window.affirm.ui.ready) {
        window.affirm.ui.ready(function () { if (window.affirm.ui.refresh) window.affirm.ui.refresh(); });
      }
    } catch (e) { /* Affirm unavailable: message simply stays as it was */ }
  };

  /* Metal label for the "Solid ..." trust line. Uses metal-like options first, then the product title.
     Returns '' (line hidden) when no metal is known or the piece is plated/vermeil. */
  PDP.prototype.goldLabel = function (v) {
    var karat = '', color = '', other = '', plated = false;
    var scan = function (val, allowColor) {
      var s = low(val);
      if (/plated|vermeil|filled/.test(s)) plated = true;
      var m = s.match(/(^|[^\d])(9|10|14|18|22|24)\s*k/);
      if (m) karat = m[2] + 'K';
      if (/platinum/.test(s)) other = 'Platinum';
      else if (/silver/.test(s) && !karat) other = 'Sterling Silver';
      if (allowColor) { var c = colorKey(s); if (c) color = c.charAt(0).toUpperCase() + c.slice(1); }
    };
    this.options.forEach(function (o) {
      var metalish = o.kind === 'metal' || o.kind === 'karat' || o.kind === 'color' || o.el.hasAttribute('data-metalish');
      if (metalish) scan(v.options[o.idx] || '', true);
    });
    if (!karat && !color && !other) scan(this.title, /gold/i.test(this.title));
    if (plated) return '';
    if (other === 'Platinum' && !karat) return 'Platinum';
    if (other && !karat && !color) return other;
    if (!karat && !color) return '';
    return (karat ? karat + ' ' : '') + (color ? color + ' ' : '') + 'Gold';
  };

  PDP.prototype.allChosen = function () {
    return !(this.sizeIndex > -1 && this.state[this.sizeIndex] == null);
  };
  PDP.prototype.syncDynamic = function () {
    var d = this.root.querySelector('[data-ish-dynamic]');
    if (!d) return;
    var propSel = this.root.querySelector('[data-ish-size-prop] select');
    d.hidden = !this.allChosen() || !!(propSel && !propSel.value);
  };

  /* ---------- Gallery ---------- */
  PDP.prototype.initGallery = function () {
    var self = this, r = this.root;
    this.track = r.querySelector('[data-ish-track]');
    this.slides = qsa(r, '[data-ish-slide]');
    this.thumbItems = qsa(r, '[data-ish-thumb-item]');
    this.count = r.querySelector('[data-ish-count]');
    var shapeVals = this.shapeOpt ? qsa(this.shapeOpt.el, 'input[type=radio]').map(function (x) { return shapeKey(x.value); }) : [];
    this.slides.forEach(function (s) {
      var text = low(s.dataset.text), file = low(s.dataset.file);
      s._shapes = shapeVals.filter(function (k) {
        return word(text, k) || word(file, k) || (SHAPES[k] || []).some(function (c) { return word(file.replace(/@/g, '-'), c); });
      });
      s._colors = Object.keys(COLORS).filter(function (c) {
        return word(text, c) || word(file, c) || new RegExp('@' + COLORS[c] + '[-_.]').test(file);
      });
    });
    qsa(r, '[data-ish-thumb]').forEach(function (b) {
      b.addEventListener('click', function () { self.goTo(self.slides[parseInt(b.dataset.ishThumb, 10)]); });
    });
    var prev = r.querySelector('[data-ish-prev]'), next = r.querySelector('[data-ish-next]');
    if (prev) prev.addEventListener('click', function () { self.step(-1); });
    if (next) next.addEventListener('click', function () { self.step(1); });
    if (this.track) {
      var t;
      this.track.addEventListener('scroll', function () { cancelAnimationFrame(t); t = requestAnimationFrame(function () { self.syncActive(); }); }, { passive: true });
      this.track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); self.step(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); self.step(-1); }
      });
    }
  };

  PDP.prototype.filterGallery = function (v, initial) {
    if (!this.slides || !this.slides.length) return;
    var shape = this.shapeOpt ? shapeKey(v.options[this.shapeOpt.idx]) : null;
    var color = null;
    for (var i = 0; i < this.metalOpts.length; i++) { color = colorKey(v.options[this.metalOpts[i].idx]) || color; }
    var shapeOk = function (s) { return !shape || !s._shapes.length || s._shapes.indexOf(shape) > -1; };
    var colorOk = function (s) { return !color || !s._colors.length || s._colors.indexOf(color) > -1; };
    var isVid = function (s) { return /video/.test(s.dataset.type || ''); };
    var vis = this.slides.map(function (s) { return shapeOk(s) && (isVid(s) || colorOk(s)); });
    var self = this;
    var colourVid = this.slides.some(function (s, i) { return vis[i] && isVid(s) && s._colors.length && colorOk(s); });
    if (colourVid) this.slides.forEach(function (s, i) { if (isVid(s) && !colorOk(s)) vis[i] = false; });
    var anyImg = this.slides.some(function (s, i) { return vis[i] && !isVid(s); });
    if (!anyImg) vis = this.slides.map(function () { return true; });
    this.slides.forEach(function (s, i) {
      s.hidden = !vis[i];
      if (self.thumbItems[i]) self.thumbItems[i].hidden = !vis[i];
    });
    this.visible = this.slides.filter(function (s, i) { return vis[i]; });
    var target = this.visible.filter(function (s) { return String(s.dataset.mediaId) === String(v.media); })[0] || this.visible[0];
    this.goTo(target, initial);
  };

  PDP.prototype.goTo = function (slide, instant) {
    if (!slide || !this.track) return;
    this.track.scrollTo({ left: slide.offsetLeft, behavior: instant ? 'auto' : 'smooth' });
    this.setActive(slide);
  };
  PDP.prototype.step = function (d) {
    var vis = this.visible || this.slides, i = vis.indexOf(this.active);
    this.goTo(vis[(i + d + vis.length) % vis.length]);
  };
  PDP.prototype.syncActive = function () {
    var vis = this.visible || this.slides, w = this.track.clientWidth || 1;
    var s = vis[Math.round(this.track.scrollLeft / w)];
    if (s && s !== this.active) this.setActive(s);
  };
  PDP.prototype.setActive = function (slide) {
    var self = this;
    this.active = slide;
    var vis = this.visible || this.slides;
    this.slides.forEach(function (s, i) {
      var on = s === slide;
      var b = self.thumbItems[i] && self.thumbItems[i].querySelector('button');
      if (b) b.setAttribute('aria-current', on ? 'true' : 'false');
      var vid = s.querySelector('video');
      if (vid) { if (on) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); } else vid.pause(); }
    });
    if (this.count) this.count.textContent = (vis.indexOf(slide) + 1) + ' / ' + vis.length;
  };

  /* ---------- Sticky bar ---------- */
  PDP.prototype.initSticky = function () {
    var self = this, bar = this.root.querySelector('[data-ish-sticky]');
    if (!bar || !('IntersectionObserver' in window)) return;
    bar.hidden = false;
    var btn = bar.querySelector('[data-ish-sticky-btn]');
    new IntersectionObserver(function (en) {
      var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
    }).observe(this.atc);
    btn.addEventListener('click', function () {
      if (!self.validate()) return;
      if (self.form.requestSubmit) self.form.requestSubmit(self.atc); else self.atc.click();
    });
  };

  /* ---------- PDP v2 extras: shipping details link, share, drop a hint ---------- */
  PDP.prototype.initExtras = function () {
    var r = this.root;
    var openShip = r.querySelector('[data-ish-open-ship]'), acc = r.querySelector('[data-ish-ship-acc]');
    if (openShip && acc) openShip.addEventListener('click', function (e) {
      e.preventDefault(); acc.open = true; acc.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var s = acc.querySelector('summary'); if (s) s.focus({ preventScroll: true });
    });
    var share = r.querySelector('[data-ish-share]');
    if (share) share.addEventListener('click', function () {
      var data = { title: share.dataset.title, url: share.dataset.url };
      if (navigator.share) { navigator.share(data).catch(function () {}); return; }
      if (navigator.clipboard) {
        navigator.clipboard.writeText(data.url).then(function () { share.textContent = 'Link copied'; setTimeout(function () { share.textContent = 'Share'; }, 2000); }).catch(function () {});
      }
    });
    // "Chat now": open the Shopify Inbox chat (app embed). Falls back to the contact page if the widget is not on the page.
    var chat = r.querySelector('[data-ish-chat]');
    // Capture phase + stopImmediatePropagation + a short delay: Shopify Inbox treats the still-bubbling original
    // click as an outside click and closes the chat it just opened (THEME-005).
    // THEME-006 (2026-10-10): works on slow devices and never leaves a dead link. Waits up to 3 s for the widget
    // (it loads async), opens it, checks it really opened, tries once more, otherwise goes to the contact page.
    // Shopify Inbox has no documented storefront API to open the chat, so the widget's own button is used.
    if (chat) {
      var chatBusy = false;
      var chatLabel = null;
      for (var ci = chat.childNodes.length - 1; ci >= 0; ci--) {
        if (chat.childNodes[ci].nodeType === 3 && chat.childNodes[ci].textContent.trim()) { chatLabel = chat.childNodes[ci]; break; }
      }
      var chatText = chatLabel ? chatLabel.textContent : '';
      // Shopify Inbox renders <shopify-chat> > shadow > <shopify-agent-runtime> > shadow > button[part=activator].
      var deepFind = function (root, sel, depth) {
        if (!root || depth > 5) return null;
        var hit = root.querySelector(sel); if (hit) return hit;
        var all = root.querySelectorAll('*');
        for (var i = 0; i < all.length; i++) { if (all[i].shadowRoot) { var f = deepFind(all[i].shadowRoot, sel, depth + 1); if (f) return f; } }
        return null;
      };
      var findActivator = function () {
        var host = document.querySelector('shopify-chat, inbox-online-store-chat, #ShopifyChat');
        if (!host) return null;
        var btn = deepFind(host.shadowRoot || host, '[part="activator"], button[aria-label="Chat"]', 0);
        return btn ? { host: host, btn: btn } : null;
      };
      // The widget re-renders its button, so always look it up again instead of keeping an old reference.
      var fresh = function (w) { var f = findActivator(); return f || w; };
      var isOpen = function (w) {
        if (w.btn.getAttribute('aria-expanded') !== 'true') return false;
        var d = deepFind(w.host.shadowRoot || w.host, '[role="dialog"]', 0);
        return !!(d && d.getBoundingClientRect().width > 0);
      };
      var setBusy = function (on) {
        chatBusy = on;
        if (on) chat.setAttribute('aria-busy', 'true'); else chat.removeAttribute('aria-busy');
        if (chatLabel) chatLabel.textContent = on ? 'Opening chat…' : chatText;
      };
      var fallback = function () {
        setBusy(false);
        window.location.href = chat.dataset.fallback || chat.getAttribute('href') || '/pages/contact-us';
      };
      var openChat = function (w) {
        if (isOpen(w)) { setBusy(false); return; }
        setTimeout(function () {
          w = fresh(w);
          if (w.btn.getAttribute('aria-expanded') !== 'true') w.btn.click();
          setTimeout(function () {
            w = fresh(w);
            if (isOpen(w)) { setBusy(false); return; }
            if (w.btn.getAttribute('aria-expanded') !== 'true') w.btn.click(); // one more try
            setTimeout(function () { w = fresh(w); if (isOpen(w)) setBusy(false); else fallback(); }, 800);
          }, 800);
        }, 60);
      };
      chat.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (chatBusy) return;
        setBusy(true);
        var w = findActivator();
        if (w) { openChat(w); return; }
        var tries = 0;
        var poll = setInterval(function () {
          tries++;
          var found = findActivator();
          if (found) { clearInterval(poll); openChat(found); }
          else if (tries >= 20) { clearInterval(poll); fallback(); } // 20 x 150 ms = 3 s
        }, 150);
      }, true);
    }
    var hint = r.querySelector('[data-ish-hint]');
    if (hint && navigator.share) hint.addEventListener('click', function (e) {
      e.preventDefault();
      navigator.share({ title: 'A hint from me', text: 'A hint from me', url: share ? share.dataset.url : window.location.href }).catch(function () {});
    });
  };

  /* ---------- Size dialog ---------- */
  PDP.prototype.initDialog = function () {
    var d = this.root.querySelector('[data-ish-size-dialog]');
    if (!d) return;
    qsa(this.root, '[data-ish-open-size]').forEach(function (b) {
      b.addEventListener('click', function () { if (d.showModal) d.showModal(); else d.setAttribute('open', ''); });
    });
    d.querySelector('[data-ish-close-size]').addEventListener('click', function () { if (d.close) d.close(); else d.removeAttribute('open'); });
    d.addEventListener('click', function (e) { if (e.target === d && d.close) d.close(); });
  };

  /* ---------- Add to cart ---------- */
  PDP.prototype.clearError = function () {
    this.err.hidden = true; this.err.textContent = '';
    qsa(this.root, '.ish-select.is-error').forEach(function (s) { s.classList.remove('is-error'); s.querySelector('select').removeAttribute('aria-invalid'); });
  };
  PDP.prototype.validate = function () {
    var sel = null;
    if (this.sizeIndex > -1 && this.state[this.sizeIndex] == null) {
      sel = this.options.filter(function (o) { return o.kind === 'size'; })[0].el.querySelector('select');
    } else {
      var p = this.root.querySelector('[data-ish-size-prop] select');
      if (p && !p.value) sel = p;
    }
    if (!sel) return true;
    this.err.textContent = this.isRing ? 'Please choose your ring size.' : 'Please choose a size.';
    this.err.hidden = false;
    sel.parentNode.classList.add('is-error');
    sel.setAttribute('aria-invalid', 'true');
    // Instant scroll: a smooth scroll is cancelled by the focus() call in some mobile browsers.
    sel.scrollIntoView({ block: 'center' });
    sel.focus({ preventScroll: true });
    return false;
  };
  PDP.prototype.submit = function (e) {
    var self = this;
    e.preventDefault();
    if (!this.validate()) return;
    this.clearError();
    this.atc.classList.add('is-loading');
    var body = new FormData(this.form);
    fetch(this.root.dataset.cartAdd + '.js', {
      method: 'POST', body: body, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
    }).then(function (res) {
      return res.json().then(function (json) { return { ok: res.ok, json: json }; });
    }).then(function (r) {
      if (!r.ok) throw new Error(r.json.description || r.json.message || 'Could not add to cart.');
      var drawer = window.theme && window.theme.settings && window.theme.settings.cartType === 'drawer';
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: r.json, addToCartBtn: self.atc } }));
      if (!drawer) window.location.href = self.root.dataset.cartUrl;
    }).catch(function (err) {
      self.err.textContent = err.message || 'Something went wrong. Please try again.';
      self.err.hidden = false;
    }).then(function () { self.atc.classList.remove('is-loading'); });
  };

  function init() { qsa(document, '[data-ish-pdp]').forEach(function (el) { if (!el._ish) el._ish = new PDP(el); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();